import { helper } from "@brainspore/celadon-base/utils";
export default {
  methods: {
    /**
     * Get date format
     * @param date
     * @returns {string|*}
     */
    formatDatePipe: function (date) {
      return helper.getDateTimeFormat(date);
    },
  },
};
